module.exports = __webpack_public_path__ + "media/1alB-a'-cha'.44a2367e.mp3";